import {Grid} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React from 'react'

import {DisplayableOrder} from '../utils'
import {useClasses} from './classes'
import {Order} from './order'

type OrderListProps = {
  orders: DisplayableOrder[]
  onClick: (string) => void
  activeOrderID: string
}

export const OrderList: React.FC<OrderListProps> = ({orders, onClick, activeOrderID}) => {
  const classes = useClasses()

  return (
    <>
      {orders.map((o, i) => {
        const selected = activeOrderID === o.id
        const className = selected ? clsx(classes.selectedOrderCard, classes.orderCard) : classes.orderCard
        return (
          <Grid key={i} className={className}>
            <Order onClick={() => onClick(o.id)} order={o} />
          </Grid>
        )
      })}
    </>
  )
}
